<mat-slide-toggle disableRipple (change)="checkChanged($event)" class="slide-toggle--soft" data-on="%" data-off="$"
  [autofocus]="autofocus" [checked]="checked" (keyup.arrowLeft)="arrowLeft()" (keyup.arrowRight)="arrowRight()"
  [disabled]="disabled">
</mat-slide-toggle>